import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { LoginService } from '../../../login/login.service';
import {
  IEventoGenerico,
  IFilter,
  IPopulate,
  IQueryParam,
  ISirena,
} from 'modelos/src';
import {
  IColumnas,
  ICrearBoton,
} from '../../../../auxiliares/tabla/tabla.component';
import { firstValueFrom, Subscription } from 'rxjs';
import { HelperService } from '../../../../auxiliares/servicios/helper.service';
import {
  IFiltroTabla,
  IRegExpSearch,
} from '../../../../auxiliares/tabla/filtro/filtro.component';
import { Lista2Service } from '../../../../auxiliares/servicios/lista2.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SirenasHttpService } from '../../../../auxiliares/servicios/http/sirenas.service';
import { DialogService } from '../../../../auxiliares/dialog/dialog.service';
import { MatDialog } from '@angular/material/dialog';
import { CamarasMultipleComponent } from '../../../standalone/camaras-multiple/camaras-multiple.component';
import { fechaCelda, haceCelda } from '../../../../auxiliares/tabla/celdas';
import { IEstadoCelda } from '../../../../auxiliares/tabla/tabla.interfaces';
import {
  CrearEditarEventoTecnicoGenericoComponent,
  ICrearEditarEventoTecnicoGenericoData,
} from '../../eventos-genericos/eventos-tecnicos-genericos/crear-editar/crear-editar-evento-tecnico-generico.component';
import { EventosGenericosHttpService } from '../../../../auxiliares/servicios/http/eventos-genericos.service';
import { ServicioTecnicoMasivoComponent } from '../servicio-tecnico-masivo/servicio-tecnico-masivo.component';
import { ClienteJerarquiaService } from '../../../../auxiliares/servicios/cliente-jerarquia.service';
import { FormularioDialogService } from '../../../../auxiliares/servicios/formulario-dialog.service';

@Component({
  selector: 'app-listado-sirenas',
  templateUrl: './listado-sirenas.component.html',
  styleUrl: './listado-sirenas.component.scss',
  standalone: false,
})
export class ListadoSirenasComponent implements OnInit, OnDestroy {
  public loading = signal(false);
  public clientePropio = LoginService.getCliente();
  //// Tabla nueva
  public name = 'ListadoSirenasGComponent';
  public sirenas?: ISirena[];
  public totalCount = signal(0);
  public columnas?: IColumnas<ISirena>[];

  //Subs
  public sirenas$?: Subscription;
  // Injectables
  private clienteJerarquia = inject(ClienteJerarquiaService);
  public helper = inject(HelperService);
  private lista2 = inject(Lista2Service);
  private navigator = inject(Router);
  private route = inject(ActivatedRoute);
  private service = inject(SirenasHttpService);
  private dialogService = inject(DialogService);
  private dialog = inject(MatDialog);
  private formularios = inject(FormularioDialogService);
  private eventosService = inject(EventosGenericosHttpService);
  //
  public botonSync: ICrearBoton = {
    mostrar: this.helper.esNivel0(),
    tooltip: 'Sincronizar sirenas',
    color: 'primary',
    tipo: 'material',
    icon: 'sync',
    accion: () => this.sync(),
  };

  public botonServicioTecnicoMasivo: ICrearBoton = {
    mostrar: this.helper.tienePermiso('Sirenas Municipales - Editar'),
    tooltip: 'Servicio técnico masivo',
    color: 'primary',
    tipo: 'material',
    icon: 'build',
    accion: () => this.abrirServicioTecnicoMasivo(),
  };

  private hasSyncedOnInit = false;

  //Buscar
  public search: IRegExpSearch = {
    fields: ['chipId', 'tipo', 'direccion', 'tipo'],
  };

  // FILTROS
  //Cliente
  public cliente: IFiltroTabla = {
    filter: {
      field: 'idCliente',
    },
    label: 'Cliente',
    tipo: 'cliente-selector',
    filtroSelector: ['moduloSirenas'],
  };
  // Cliente en cuya jerarquía cuelga la entidad: el cliente elegido y toda su
  // descendencia.
  public ancestro: IFiltroTabla = {
    filter: {
      field: 'idsAncestros',
      incluirPropio: true,
    },
    label: 'En la jerarquía de',
    tipo: 'cliente-selector',
  };
  private chipId: IFiltroTabla = {
    elementos: [],
    filter: {
      field: 'chipId',
    },
    label: 'Chip ID',
    tipo: 'input',
  };
  private estado: IFiltroTabla = {
    elementos: [
      { label: 'En línea', value: 'Online' },
      { label: 'Sin conexión', value: 'Offline' },
    ],
    tipo: 'select',
    label: 'Estado',
    rapido: true,
    selectLabel: 'label',
    selectValue: 'value',
    filter: {
      field: 'estado',
    },
  };
  private offlinePorTiempo: IFiltroTabla = {
    elementos: [
      {
        label: 'Más de 1 día',
        value: { $lte: new Date().setDate(new Date().getDate() - 1) },
      },
      {
        label: 'Menos de 1 día',
        value: { $gte: new Date().setDate(new Date().getDate() - 1) },
      },
    ],
    tipo: 'select',
    label: 'Tiempo sin conexión',
    selectLabel: 'label',
    selectValue: 'value',
    filter: {
      field: 'offlineDesde',
    },
  };
  private onlinePorTiempo: IFiltroTabla = {
    elementos: [
      {
        label: 'Más de 1 día',
        value: { $lte: new Date().setDate(new Date().getDate() - 1) },
      },
      {
        label: 'Menos de 1 día',
        value: { $gte: new Date().setDate(new Date().getDate() - 1) },
      },
    ],
    tipo: 'select',
    label: 'Tiempo en línea',
    selectLabel: 'label',
    selectValue: 'value',
    filter: {
      field: 'onlineDesde',
    },
  };
  private modelo: IFiltroTabla = {
    elementos: [],
    tipo: 'select',
    label: 'Modelo',
    selectLabel: 'marca',
    selectValue: '_id',
    filter: {
      field: 'idModelo',
    },
  };
  private activa: IFiltroTabla = {
    elementos: [
      { label: 'Activa', value: true },
      { label: 'Inactiva', value: false },
    ],
    tipo: 'select',
    label: 'Activa',
    rapido: true,
    selectLabel: 'label',
    selectValue: 'value',
    filter: {
      field: 'activa',
    },
  };
  private tipo: IFiltroTabla = {
    tipo: 'input',
    label: 'Tipo',
    filter: {
      field: 'tipo',
    },
  };

  public filtros: IFiltroTabla[] = [
    this.cliente,
    this.ancestro,
    this.chipId,
    this.modelo,
    this.estado,
    this.tipo,
    this.activa,
    this.offlinePorTiempo,
    this.onlinePorTiempo,
  ];

  //Query
  public filter: IFilter<ISirena> = {};
  public populate: IPopulate[] = [
    {
      path: 'cliente',
      select: 'nombre',
    },
    {
      path: 'modelo',
      select: 'marca modelo',
    },
    {
      path: 'camaras',
      select: 'identificacion',
    },
  ];
  public query: IQueryParam = {
    filter: JSON.stringify(this.filter),
    populate: JSON.stringify(this.populate),
    sort: 'chipId',
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: true,
    childrenLevel: 0,
  };

  // Acciones
  public async crear() {
    this.navigator.navigate(['crear'], { relativeTo: this.route });
  }

  public async editar(sirena: ISirena) {
    this.navigator.navigate(['editar', sirena._id], {
      relativeTo: this.route,
    });
  }

  public async eliminar(sirena: ISirena) {
    const res = await this.dialogService.confirm(
      'Eliminar sirena',
      `¿Querés eliminar la sirena?`,
    );
    if (!res) return;
    try {
      await this.service.delete(sirena._id!);
      this.helper.notifSuccess('Sirena eliminada');
      await this.listar();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  public async exportarEventos(sirena: ISirena) {
    const rango = await this.dialogService.dateRange(
      'Exportar eventos',
      'Seleccioná el rango de fechas para exportar los eventos',
    );
    if (!rango) return;

    const filter: IFilter<IEventoGenerico> = {
      idEntidad: sirena._id,
      fechaCreacion: {
        $gte: rango?.start,
        $lte: rango?.end,
      },
    };

    const populate: IPopulate[] = [
      {
        path: 'sirena',
        select: '_id',
      },
      {
        path: 'cliente',
        select: 'nombre',
      },
    ];

    const query: IQueryParam = {
      filter: JSON.stringify(filter),
      sort: 'fechaCreacion',
      page: 0,
      limit: 0,
      unlimited: true,
      includeChildren: true,
      populate: JSON.stringify(populate),
    };

    const config = {
      columns: [
        {
          header: 'Cliente',
          key: 'cliente.nombre',
        },
        {
          header: 'Categoría',
          key: 'categoria',
        },
        {
          header: 'Entidad',
          key: 'sirena._id',
        },
        {
          header: 'Evento',
          key: 'valores.titulo',
        },
        {
          header: 'Detalles',
          key: 'valores.mensaje',
        },
        {
          header: 'Fecha',
          key: 'valores.timestamp',
        },
        {
          header: 'Origen',
          key: 'valores.origen',
        },
        {
          header: 'Efecto',
          key: 'valores.efecto',
        },
        {
          header: 'Vecino',
          key: 'valores.nombreVecino',
        },
        {
          header: 'Teléfono Vecino',
          key: 'valores.telefono',
        },
        {
          header: 'Usuario Monitoreo',
          key: 'valores.usuario',
        },
        {
          header: 'Dirección Sirena',
          key: 'valores.direccion',
        },
      ],
      sheetName: 'Eventos',
      autoFilter: true,
    };

    try {
      await this.eventosService.exportar(query, config, sirena._id);
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  public async sync() {
    const res = await this.dialogService.confirm(
      'Sincronizar sirenas',
      `¿Querés sincronizar las sirenas?`,
      'Aceptar',
      'Cancelar',
    );
    if (!res) return;
    try {
      await this.service.sync();
      this.helper.notifSuccess('Sirenas sincronizadas');
      await this.listar();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  private async syncAuto() {
    try {
      await this.service.sync();
      this.helper.notifSuccess('Sirenas sincronizadas automáticamente');
      await this.listar();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  private async verStream(sirena: ISirena) {
    const idsCamaras: string[] = [];
    sirena.camaras.map((c) => idsCamaras.push(c._id!));
    if (idsCamaras.length === 0) {
      this.helper.notifWarn('La sirena no tiene una cámara asignada');
      return;
    }

    CamarasMultipleComponent.open(this.dialog, { data: idsCamaras });
  }

  public abrirServicioTecnicoMasivo() {
    this.formularios.abrir(ServicioTecnicoMasivoComponent, {
      tamano: 'grande',
    });
  }

  private async crearServicioTecnico(sirena: ISirena) {
    const data: ICrearEditarEventoTecnicoGenericoData = {
      idEntidad: sirena._id!,
      tipoEvento: 'Evento Técnico Sirena',
      categoria: 'Sirena',
      idsCQAET: [this.clientePropio!._id!],
    };

    this.formularios.abrir(CrearEditarEventoTecnicoGenericoComponent, {
      tamano: 'grande',
      data,
    });
  }

  public verDetallesIntegracion(sirena: ISirena): void {
    // El detalle de la integración es una página (antes un diálogo)
    this.navigator.navigate(
      ['main/sirenas/sirenas/detalles', sirena.idExterno || sirena._id],
      {
        queryParams: sirena.idCliente ? { cliente: sirena.idCliente } : {},
      },
    );
  }

  /// Listados

  public async listar(): Promise<void> {
    this.sirenas$?.unsubscribe();
    this.sirenas$ = this.lista2
      .sirenasG(this.query, 30)
      .subscribe(async (data) => {
        this.sirenas = data.datos;
        this.totalCount.set(data.totalCount);
        if (!this.hasSyncedOnInit) {
          const primera = this.sirenas?.[0];
          const fechaSync = primera?.fechaSincronizacion
            ? new Date(primera.fechaSincronizacion).getTime()
            : 0;
          const diez_minutos = 10 * 60 * 1000;
          if (!this.sirenas?.length || Date.now() - fechaSync > diez_minutos) {
            this.hasSyncedOnInit = true;
            await this.syncAuto();
          } else {
            this.hasSyncedOnInit = true;
          }
        }
      });
  }

  /**
   * Estado de la sirena. Sólo 'Online' y 'Offline' son estados conocidos;
   * sin estado es falta de dato (antes cualquier otro valor salía 'Offline').
   */
  private estadoSirena(dato: ISirena): IEstadoCelda | undefined {
    if (!dato.estado) return undefined;
    const online = dato.estado === 'Online';
    const offline = dato.estado === 'Offline';
    const desde = online
      ? dato.onlineDesde
      : offline
        ? dato.offlineDesde
        : undefined;
    const base: IEstadoCelda = online
      ? { texto: 'En línea', tono: 'ok', icono: 'cloud_done' }
      : offline
        ? { texto: 'Sin conexión', tono: 'error', icono: 'cloud_off' }
        : { texto: dato.estado, tono: 'neutro', icono: 'question_mark' };
    const fecha = fechaCelda(desde);
    return {
      ...base,
      tooltip: fecha ? `Desde ${fecha}` : undefined,
      detalle: fecha ? `desde ${haceCelda(desde)}` : undefined,
    };
  }

  private setColumnas() {
    const columnas: IColumnas<ISirena>[] = [
      // Fecha de sincronización
      {
        header: {
          label: 'Fecha de sincronización',
        },
        row: {
          fecha: (dato) => dato.fechaSincronizacion,
          hace: true,
          noData: 'Sin sincronizar',
        },
      },
      // Estado
      {
        header: {
          label: 'Estado',
        },
        row: {
          estado: (dato) => this.estadoSirena(dato),
          noData: 'Sin estado',
        },
      },
      // Modelo
      {
        header: {
          label: 'Modelo',
        },
        row: {
          parse(dato) {
            const texto = [dato.modelo?.marca, dato.modelo?.modelo]
              .filter(Boolean)
              .join(' - ');
            return texto || undefined;
          },
          noData: 'Sin modelo',
        },
      },
      // Tipo: sin tipo es una sirena común (valor, no falta de dato)
      {
        header: {
          label: 'Tipo',
        },
        row: {
          parse: (dato) => dato.tipo || 'Sirena',
        },
      },
      // Chip ID
      {
        header: {
          label: 'Chip ID',
          sortable: true,
          sort: 'chipId',
        },
        row: {
          field: 'chipId',
          noData: 'Sin chip ID',
        },
      },
      // Cámaras
      {
        header: {
          label: 'Cámaras',
        },
        row: {
          lista(dato) {
            const camaras = dato.camaras?.map((c) => c.identificacion);
            return camaras || [];
          },
          noData: 'Sin cámaras',
        },
      },
      // Dirección
      {
        header: {
          label: 'Dirección',
        },
        row: {
          parse(dato) {
            return HelperService.extraerDireccion(dato.direccion);
          },
          tooltip(dato) {
            return dato.direccion;
          },
          noData: 'Sin dirección',
        },
      },
    ];

    // Cliente
    if (HelperService.getTipoCliente() !== 'Final') {
      {
        columnas.push({
          header: {
            label: 'Cliente',
          },
          row: {
            html: (dato) => this.clienteJerarquia.htmlNombre(dato.cliente),
            tooltip: (dato) =>
              this.clienteJerarquia.tooltipJerarquia(dato.cliente),
          },
        });
      }
    }

    // Acciones (orden y submenú Más acciones como estaban)
    columnas.push({
      header: {
        label: 'Acciones',
      },
      row: {
        accionesGrouped: [
          // Detalle de la integración
          {
            tipo: 'material',
            color: 'primary',
            icon: 'visibility',
            tooltip: 'Ver detalle de la integración',
            click: (dato) => this.verDetallesIntegracion(dato),
          },
          // Editar
          {
            tipo: 'material',
            color: 'primary',
            icon: 'edit',
            tooltip: 'Editar',
            click: (dato) => this.editar(dato),
            disabled: () =>
              !this.helper.tienePermiso('Sirenas Municipales - Editar'),
          },
          // Eliminar
          {
            tipo: 'material',
            color: 'warn',
            icon: 'delete',
            tooltip: 'Eliminar',
            click: (dato) => this.eliminar(dato),
            disabled: () =>
              !this.helper.tienePermiso('Sirenas Municipales - Eliminar'),
          },
          // ... Más
          {
            tipo: 'material',
            icon: 'more_vert',
            tooltip: 'Más acciones',
            children: [
              // Servicio técnico
              {
                tipo: 'material',
                color: 'primary',
                icon: 'build',
                tooltip: 'Servicio técnico',
                click: (dato) => this.crearServicioTecnico(dato),
                disabled: () =>
                  !this.helper.tienePermiso('Sirenas Municipales - Editar'),
              },
              // Exportar eventos
              {
                tipo: 'material',
                color: 'primary',
                icon: 'file_download',
                tooltip: 'Exportar eventos',
                click: (dato) => this.exportarEventos(dato),
                // disabled: () => !this.helper.tienePermiso('Export'), // TODO-PERMISO: no hay AccionRol equivalente
              },
              // Ver stream
              {
                tipo: 'material',
                color: 'primary',
                icon: 'videocam',
                tooltip: 'Ver cámaras en vivo',
                click: (dato) => this.verStream(dato),
                disabled: (dato) => {
                  const permiso = this.helper.tienePermiso(
                    'Cámaras - Ver streaming',
                  );
                  const idCamara = dato.idsAsignados?.[0];
                  return !idCamara || !permiso;
                },
              },
            ],
          },
        ],
      },
    });

    this.columnas = columnas;
  }

  /// Hooks

  public async ngOnInit() {
    this.setColumnas();
    await Promise.all([this.listar()]);
  }

  public ngOnDestroy() {
    this.sirenas$?.unsubscribe();
  }
}
